import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import FavoriteCheckbox from "../FavoriteCheckbox/FavoriteCheckbox";
import ModalTextInput from "../ModalTextInput/TextInput";
import Button from "@src/multiCustodian/components/MUI/Button/Button";
import LogoLoadingStill from "@src/sharedComponents/LogoLoadingStill/LogoLoadingStill";
import ModalWithClearButton from "@src/sharedComponents/Modal/ModalWithClearButton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ItemDetailsModal.module.css";

interface Props {
  title: string;
  textInputLabel: string;
  textInputValue: string;
  setTextInput: (s: string) => void;
  isChecked: boolean;
  checkboxLabel: string;
  checkboxSubtext: string;
  setCheckbox: (checked: boolean) => void;
  deleteButtonText: string;
  showDeleteModal: () => void;
  goBack: () => void;
  onSave: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

const ItemDetailsModal: React.FC<Props> = ({
  title,
  textInputLabel,
  textInputValue,
  setTextInput,
  isChecked,
  checkboxLabel,
  checkboxSubtext,
  setCheckbox,
  deleteButtonText,
  showDeleteModal,
  goBack,
  onSave,
  isLoading,
  isDisabled,
}: Props) => {
  return (
    <ModalWithClearButton closeModal={goBack}>
      {isLoading && <LogoLoadingStill onTop />}

      <div className={styles.titleRow}>
        <ArrowBackIcon className={styles.backArrowIcon} onClick={goBack} />

        <Text variant={"title2"} className={styles.title}>
          {title}
        </Text>
      </div>

      <ModalTextInput
        label={<div className={styles.textInputLabel}>{textInputLabel}</div>}
        value={textInputValue}
        onChange={setTextInput}
        isDisabled={false}
      />

      <FavoriteCheckbox
        label={checkboxLabel}
        text={checkboxSubtext}
        isFavorite={isChecked}
        setIsFavorite={setCheckbox}
        isDisabled={false}
      />

      <div className={styles.footer}>
        <div className={styles.flexRow}>
          <div className={styles.deleteText} onClick={showDeleteModal}>
            {deleteButtonText}
          </div>
        </div>

        <div className={styles.flexRow}>
          <Button
            text={"Cancel"}
            variant={"outlined"}
            buttonType={"secondary"}
            onClick={goBack}
            sx={{ width: "80px" }}
          />

          <Button
            text={"Save"}
            variant={"contained"}
            buttonType={"primary"}
            onClick={onSave}
            sx={{ marginLeft: "20px", width: "80px" }}
            disabled={isDisabled}
          />
        </div>
      </div>
    </ModalWithClearButton>
  );
};

export default ItemDetailsModal;
